/* Les BBQ catering inquiry: preselect experience from ?experience=, require picks, pack picks into the 300-char description field, validate before reCAPTCHA submit */
(function () {
  var MAX = 300, submitted = false;
  var form = document.getElementById('rcs_form_1058');
  if (!form) return;
  var notes = document.getElementById('lbc-notes');
  var desc = document.getElementById('description');
  var count = document.getElementById('lbc-count');
  var les = document.getElementById('lbc-les');

  function vals(name) {
    return Array.prototype.slice.call(form.querySelectorAll('input[name="' + name + '"]:checked')).map(function (i) { return i.value; });
  }
  function prefix() {
    var exp = vals('lbc_exp')[0] || '';
    if (les && les.checked) exp = (exp ? exp + ' + ' : '') + 'Les Experience';
    var parts = [];
    if (exp) parts.push('Experience: ' + exp);
    var m = vals('lbc_meat'); if (m.length) parts.push('Meats: ' + m.join(', '));
    var s = vals('lbc_side'); if (s.length) parts.push('Sides: ' + s.join(', '));
    return parts.length ? parts.join(' | ') + ' | Notes: ' : 'Notes: ';
  }
  function update() {
    var room = Math.max(MAX - prefix().length, 0);
    notes.maxLength = room;
    if (notes.value.length > room) notes.value = notes.value.slice(0, room);
    count.textContent = (room - notes.value.length) + ' characters left';
    desc.value = (prefix() + notes.value).slice(0, MAX);
  }
  form.addEventListener('change', update);
  notes.addEventListener('input', update);

  var key = (new URLSearchParams(window.location.search).get('experience') || '').toLowerCase();
  if (key === 'les') { if (les) les.checked = true; }
  else if (key) {
    var r = form.querySelector('input[name="lbc_exp"][data-key="' + key + '"]');
    if (r) r.checked = true;
  }
  update();

  function groupOk(name, errId) {
    var ok = vals(name).length > 0;
    document.getElementById(errId).classList.toggle('is-on', !ok);
    return ok;
  }

  window.rcsOnSubmit1058 = function () {
    update();
    var ok = form.reportValidity();
    var m = groupOk('lbc_meat', 'lbc-meat-err');
    var s = groupOk('lbc_side', 'lbc-side-err');
    if (!ok || !m || !s) {
      if (ok) (document.getElementById(m ? 'lbc-side-err' : 'lbc-meat-err')).scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (window.grecaptcha) grecaptcha.reset();
      return;
    }
    submitted = true;
    form.submit();
  };

  var iframe = document.getElementById('lbc-iframe');
  iframe.addEventListener('load', function () {
    if (!submitted) return;
    document.getElementById('lbc-form-wrap').style.display = 'none';
    var ok = document.getElementById('lbc-success');
    ok.classList.add('is-visible');
    ok.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
})();